import { render, staticRenderFns } from "./drive_respuestas.vue?vue&type=template&id=c6c99ec2&scoped=true&"
import script from "./drive_respuestas.vue?vue&type=script&lang=js&"
export * from "./drive_respuestas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c99ec2",
  null
  
)

export default component.exports